import axios from 'axios'
import Constants from '../constants'

export default {
  getGenres: (lang) => {
    return new Promise((resolve) => {
      axios.get('tags', { params: { id: Constants.API_ID, language: lang } })
        .then(payload => {
          let genres = []
          payload.data.items.forEach((g) => {
            const genre = {
              id: g.id,
              name: g.name,
              menu: g.menu,
              filter: g.filter,
              filterName: g.filterName,
              filterDefault: g.filterDefault,
              planTop: g.planTop,
              type: g.type
            }
            if (g.items) {
              genre.children = g.items
            }
            genres.push(genre)
          })
          resolve(genres)
        });
    })
  }
}
